module.exports = __webpack_public_path__ + "static/media/8OLA22.1e924c82.jpg";